import axios from './rest-axios';

const getAll = (data) => axios.get(`/manage/cw_zcdj_fkd`, data);
const getDetail = (id) => axios.get(`/manage/cw_zcdj_fkd/${id}`);
const postAdd = ({huhao, zhanghao, kaihuhang, ids}) => axios.post(`/manage/cw_zcdj_fkd`, {huhao, zhanghao, kaihuhang, ids});
const postRemove = (id) => axios.delete(`/manage/cw_zcdj_fkd/${id}`);
const updatefkrq = (ids, fkrq) => axios.post(`/manage/cw_zcdj_fkd/updatefkrq`, {ids, fkrq});

const getwfl = (month) => axios.get(`/manage/cw_zcdj_fkd/wfl`, {month});
const getyfl = (month, md) => axios.get(`/manage/cw_zcdj_fkd/yfl`, {month, md});
const postadd = (ids, coa_id, md) => axios.post(`/manage/cw_zcdj_fkd/add`, {ids, coa_id, md});
const postremove = (ids) => axios.post(`/manage/cw_zcdj_fkd/remove`, {ids});

const getcwzcdjstat = (month, coa_name) => axios.get(`/manage/cw_zcdj_fkd/stat`, {month, coa_name});
const getcwzcdjstatyue = (year, coa_name) => axios.get(`/manage/cw_zcdj_fkd/statyue`, {year, coa_name});


export {
    getAll,
    getDetail,
    postAdd,
    postRemove,
    updatefkrq,
    getwfl,
    getyfl,
    postadd,
    postremove,
    getcwzcdjstat,
    getcwzcdjstatyue,
};
